/* eslint-disable no-plusplus */
/* eslint-disable new-cap */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-loop-func */
/* eslint-disable no-restricted-syntax */
import jsPDF from "jspdf";

import { DocumentInfo, DocumentSection } from "../../models/documents";
import { handleGetAvarageEstimatedHours } from "../../pages/budget/modules/components/tabs-content/documentation-tab/components/tables/ActivityProfileTable";
import {
    defaultCostToFormattedCurrency,
    formatCurrency,
} from "../../pages/organization/project/tab-costs/utils";
import {
    TBudgetProfile,
    TReadBudgetsResponse,
} from "../../services/budget/read-budgets";
import { TReadBudgetsLevelsDetailsByIdResponse } from "../../services/budget/read-budgets-levels-detailed-by-id";

export const generatePDF = async (
    sections: DocumentSection[],
    documentInfo: DocumentInfo,
    profiles: TBudgetProfile[],
    budgetData: TReadBudgetsResponse,
    tableScopeData: TReadBudgetsLevelsDetailsByIdResponse
): Promise<void> => {
    try {
        const levelConfig = budgetData?.LevelConfig;
        const totalEstimatedHours = profiles.reduce((acc, item) => {
            const hours = parseInt(
                handleGetAvarageEstimatedHours(
                    item.BudgetProfileLevelDedicatedHours
                ) || "0",
                10
            );
            return Number.isNaN(hours) ? acc : acc + hours;
        }, 0);
        const totalValue = profiles.reduce((acc, item) => {
            const total = String(
                Number(item.costPerHour) *
                    Number(
                        handleGetAvarageEstimatedHours(
                            item.BudgetProfileLevelDedicatedHours
                        )
                    )
            );
            const value = parseFloat(total.replace(/[^\d.-]/g, "") || "0");
            return Number.isNaN(value) ? acc : acc + value;
        }, 0);

        const doc = new jsPDF();
        const formattedDate = new Date().toLocaleDateString("pt-BR");

        doc.setFont("helvetica", "bold");
        doc.setFontSize(16);
        doc.rect(20 - 2, 12, 177.5, 12);
        doc.text(
            documentInfo.document_title ||
                "DPP - Documento de Proposição de Projeto",
            20,
            20
        );

        doc.setFont("helvetica", "normal");
        doc.setFontSize(12);
        doc.rect(20 - 2, 24, 177.5, 12);
        doc.text(
            `${documentInfo.enterprise || "Empresa"} | ${
                documentInfo.project || "Projeto"
            }`,
            20,
            30
        );
        doc.text(`Data: ${formattedDate}`, 20, 35);

        let yPosition = 45;

        const sortedSections = [...sections].sort(
            (a, b) => a.position - b.position
        );

        for (const section of sortedSections) {
            if (yPosition > 270) {
                doc.addPage();
                yPosition = 20;
            }

            doc.setTextColor(0, 177, 167);
            doc.setFont("helvetica", "bold");
            doc.setFontSize(12);
            doc.text(
                `${section.position}. ${section.session_title}`,
                20,
                yPosition
            );
            doc.setTextColor(0, 0, 0);
            yPosition += 7;

            if (section.type === "tabela_de_escopo") {
                doc.setFont("helvetica", "bold");
                doc.text("Tabela de Escopo do Projeto:", 20, yPosition);
                yPosition += 7;

                levelConfig.map((level, i) => {
                    const x =
                        level.levelOrder === 1
                            ? 20
                            : level.levelOrder === 2
                            ? 80.5
                            : 141;
                    const isLastLabel = i === levelConfig.length - 1;
                    doc.rect(x - 2, yPosition - 5, isLastLabel ? 58 : 60.5, 7);
                    doc.setTextColor(0, 177, 167);
                    doc.setFontSize(10);
                    return doc.text(level.name, x, yPosition);
                });

                doc.setFont("helvetica", "normal");
                yPosition += 7;

                const tableData = tableScopeData.map(({ Level, Parent }) => {
                    const grandpa = Parent?.Parent ?? null;
                    const father = Parent;
                    return grandpa
                        ? [grandpa.name, father.name, Level.name]
                        : [father.name, Level.name];
                });

                for (const row of tableData) {
                    if (yPosition > 270) {
                        doc.addPage();
                        yPosition = 20;
                        doc.setFont("helvetica", "normal");
                        doc.setFontSize(10);
                        levelConfig.map((level, i) => {
                            const x =
                                level.levelOrder === 1
                                    ? 20
                                    : level.levelOrder === 2
                                    ? 80.5
                                    : 141;
                            const isLastLabel = i === levelConfig.length - 1;
                            doc.rect(
                                x - 2,
                                yPosition - 5,
                                isLastLabel ? 58 : 60.5,
                                7
                            );
                            return doc.text(level.name, x, yPosition);
                        });

                        yPosition += 7;
                    }
                    const colXPositions = [20, 80.5, 141];
                    for (let i = 0; i < row.length; i++) {
                        doc.setFontSize(10);
                        doc.setFont("helvetica", "normal");
                        doc.setTextColor(0, 0, 0);
                        doc.text(row[i], colXPositions[i], yPosition);
                    }
                    yPosition += 7;
                }
                yPosition += 5;
            } else if (section.type === "tabela_de_perfis_de_atividade") {
                doc.setFont("helvetica", "bold");
                doc.setFontSize(12);
                doc.text("Tabela de Perfis de Atividade:", 20, yPosition);
                yPosition += 7;

                const headers = [
                    "Função",
                    "% Calc",
                    "Perfis",
                    "Custo",
                    "Horas",
                    "Total",
                ];
                const colWidths = [30, 30, 30, 30, 27.5, 30];
                const startX = 20;

                let x = startX;
                for (let i = 0; i < headers.length; i++) {
                    doc.rect(x - 2, yPosition - 5, colWidths[i], 7);
                    doc.setFontSize(10);
                    doc.setTextColor(0, 177, 167);
                    doc.text(headers[i], x + 1, yPosition);
                    x += colWidths[i];
                }

                yPosition += 7;
                doc.setFont("helvetica", "normal");

                for (const profile of profiles) {
                    if (yPosition > 270) {
                        doc.addPage();
                        yPosition = 20;
                        x = startX;
                        doc.setFont("helvetica", "bold");
                        for (let i = 0; i < headers.length; i++) {
                            doc.rect(x, yPosition - 5, colWidths[i], 7);
                            doc.text(headers[i], x + 1, yPosition);
                            x += colWidths[i];
                        }
                        doc.setFont("helvetica", "normal");
                        yPosition += 7;
                    }

                    const {
                        costPerHour,
                        BudgetProfileLevelDedicatedHours,
                        Profile,
                        dependencyPercentage,
                        BudgetProfileTimeDependancy,
                    } = profile;

                    const total = String(
                        Number(costPerHour) *
                            Number(
                                handleGetAvarageEstimatedHours(
                                    BudgetProfileLevelDedicatedHours
                                )
                            )
                    );
                    const depends =
                        BudgetProfileTimeDependancy.map(
                            (p) => p.DependsOn.Profile.name
                        ).join(", ") || "-";
                    const row = [
                        Profile.name,
                        `${dependencyPercentage ?? "0%"}`,
                        depends,
                        defaultCostToFormattedCurrency(costPerHour) ||
                            "R$ 0,00",
                        handleGetAvarageEstimatedHours(
                            BudgetProfileLevelDedicatedHours
                        ) || "0",
                        defaultCostToFormattedCurrency(total) || "R$ 0,00",
                    ];

                    x = startX;
                    for (let i = 0; i < row.length; i++) {
                        doc.setTextColor(0, 0, 0);
                        doc.setFont("helvetica", "normal");
                        doc.text(row[i], x + 1, yPosition);
                        x += colWidths[i];
                    }
                    yPosition += 7;
                }

                doc.setFont("helvetica", "bold");
                doc.text(
                    "Total:",
                    startX + colWidths[0] + colWidths[1] + colWidths[2] + 1,
                    yPosition
                );
                doc.text(
                    `${totalEstimatedHours}`,
                    startX +
                        colWidths[0] +
                        colWidths[1] +
                        colWidths[2] +
                        colWidths[3] +
                        1,
                    yPosition
                );
                doc.text(
                    `${formatCurrency(String(totalValue))}`,
                    startX +
                        colWidths[0] +
                        colWidths[1] +
                        colWidths[2] +
                        colWidths[3] +
                        colWidths[4] +
                        1,
                    yPosition
                );
                doc.setFont("helvetica", "normal");
                doc.setFontSize(12);
                yPosition += 10;
            } else {
                const lines = section.content.split("\n");
                for (const line of lines) {
                    if (yPosition > 270) {
                        doc.addPage();
                        yPosition = 20;
                    }
                    const textWidth = 181;
                    const charsPerLine = Math.floor(textWidth / 2);

                    if (line.length > charsPerLine) {
                        const words = line.split(" ");
                        let current = "";
                        for (const word of words) {
                            if ((current + word).length > charsPerLine) {
                                doc.setFont("helvetica", "normal");
                                doc.text(current, 20, yPosition);
                                yPosition += 7;
                                current = `${word} `;
                                if (yPosition > 270) {
                                    doc.addPage();
                                    yPosition = 20;
                                }
                            } else {
                                current += `${word} `;
                            }
                        }
                        if (current.trim().length > 0) {
                            doc.setFont("helvetica", "normal");
                            doc.setFontSize(10);
                            doc.text(current, 20, yPosition);
                            yPosition += 7;
                        }
                    } else {
                        doc.setFont("helvetica", "normal");
                        doc.setFontSize(10);
                        doc.text(line, 20, yPosition);
                        yPosition += 7;
                    }
                }
                yPosition += 5;
            }
        }

        if (yPosition > 270) {
            doc.addPage();
            yPosition = 20;
        }

        doc.setFontSize(10);
        doc.text(
            `Este documento foi gerado em ${formattedDate}.`,
            20,
            yPosition
        );

        const filename = `${documentInfo.document_title || "documento"}_${
            new Date().toISOString().split("T")[0]
        }.pdf`;
        doc.save(filename);

        return Promise.resolve();
    } catch (error) {
        console.error("Erro ao gerar PDF:", error);
        return Promise.reject(error);
    }
};
